import { render, staticRenderFns } from "./product-name.vue?vue&type=template&id=31f88f08&scoped=true&"
import script from "./product-name.vue?vue&type=script&lang=js&"
export * from "./product-name.vue?vue&type=script&lang=js&"
import style0 from "./product-name.vue?vue&type=style&index=0&id=31f88f08&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31f88f08",
  null
  
)

export default component.exports